import Auth from "./Auth";
import Religion from "./Religion";
import profile from "./Profile";
import filter from "./Filter";
import Search from "./Search";
import Interest from "./Interest";
import Plan from "./Plan";
import Payment from "./Payment";
import FirebaseToken from "./FirebaseToken";
import Contact from "./Contact";
import UploadPic from "./UploadPic";
import Favourite from "./Favourite";
import Chat from "./Chat";
import Photos from "./PhotosApi";
import Admin from "./Admin";

const API = {
  Auth,
  Religion,
  profile,
  filter,
  Search,
  Interest,
  Plan,
  Payment,
  FirebaseToken,
  Contact,
  UploadPic,
  Favourite,
  Chat,
  Photos,
  Admin,
};

export default API;
